import i18n from '@/i18n'
import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'

Vue.use(Vuex);

const state = {
	CodeValue: "",
  SignalRState: false, // 接收通知状态
  DeviceStates: false, // 设备通讯状态
  DeviceUnfold: false, // 设备是否展开详情
  UserState: false, // 是否出现挤号情况
  EnergyState: false, // 报表时分加载状态
  DeviceAlarm: {}, // 警报设备详情
  UseGasState: false, // 处理安全用气通知状态
  UserItem: {}, // 用户管理跳转设备保存状态
  ThemeList: [{
    id: 1,
    name: i18n.t('store.index.598093-0'),
    code: 'default'
  }, {
    id: 2,
    name: i18n.t('store.index.598093-1'),
    code: 'blue'
  }],
  HomeModeList:[
    {
      id: 1,
      name: i18n.t('store.index.598093-2'),
      code: 'default'
    }, {
      id: 2,
      name: i18n.t('store.index.598093-3'),
      code: 'newHome'
    },
    {
      id: 3,
      name: i18n.t('store.index.598093-4'),
      code: 'DMapMode'
    }
  ],
  ThemeCode: localStorage.getItem('themeCode') || 'default',
  HomeType: localStorage.getItem('HomeType') || 'default',
}

export default new Vuex.Store({
	state,
	getters, // 获取状态入口
	mutations, // 修改状态入口（同步）
	actions // 修改设置状态（异步，建议使用异步）
})



// WEBPACK FOOTER //
// ./src/store/index.js